import React, { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import HeaderComponent from "../components/HeaderComponent";
import HeaderPlaceholder from "../components/HeaderComponent/HeaderPlaceholder";
import WelcomePage from "../pages/Welcome";
import { route, RoutePaths } from "./RoutePaths";
import AppContainer from "../components/AppContainer";
import Changelog from "../pages/Changelog";
import DeveloperTools from "../components/DeveloperTools";
import Auth from "../pages/Redirect/Auth";
import NewHome from "../pages/Redirect/Auth/NewHome";
import Sandbox from "../pages/Sandbox";
import MFA from "../pages/Auth";
// import HenryLandingPage from "../pages/Henry2.0";

const CreateAccountPage = lazy(() => import("../pages/CreateAccount"));
const EmailVerification = lazy(() => import("../pages/EmailVerification"));
const LoginPage = lazy(() => import("../pages/Login"));
const Error404 = lazy(() => import("../pages/RedirectScreens/Error404"));
const ResetPasswordPage = lazy(() => import("../pages/ResetPassword"));
const VendorCalculator = lazy(() => import("../pages/Vendor/vendorCalculator"));
const VendorSurvey = lazy(() => import("../pages/Vendor/VendorSurvey"));
const PasswordUpdatedScreen = lazy(() => import("../pages/PasswordUpdated"));

export default function NonAuthRoutes() {
  return (
    <>
      <DeveloperTools />

      <Routes>
        <Route path={RoutePaths.sandbox} element={<Sandbox />} />
        <Route path={RoutePaths.redirectAuth} element={<Auth />} />
        <Route path={RoutePaths.mfa} element={<MFA />} />
        <Route path={RoutePaths.testHomePage} element={<NewHome />} />
        <Route path={RoutePaths.index} element={<WelcomePage />} />
        <Route path={route(RoutePaths.login)} element={<LoginPage />} />
        <Route path={route(RoutePaths.resetPassword)} element={<ResetPasswordPage />} />
        <Route
          path={route(RoutePaths.createAccount)}
          element={
            <>
              {" "}
              <HeaderComponent />
              <CreateAccountPage />
            </>
          }
        />
        <Route path={route(RoutePaths.emailVerification, false)} element={<EmailVerification />} />
        <Route
          path={route(RoutePaths.error)}
          element={
            <>
              <HeaderComponent />
              <HeaderPlaceholder />
              <AppContainer id="app-container">
                <Error404 />
              </AppContainer>
            </>
          }
        />
        <Route path={RoutePaths.welcome} element={<WelcomePage />} />
        <Route path={RoutePaths.vendor} element={<WelcomePage />} />
        <Route path={RoutePaths.welcomeWithVendor} element={<WelcomePage />} />
        <Route path={RoutePaths.vendorCalculator} element={<VendorCalculator />} />
        <Route path={RoutePaths.vendorSurvey} element={<VendorSurvey />} />
        <Route path={RoutePaths.welcomeVendorCalculator} element={<VendorCalculator />} />
        <Route path={RoutePaths.welcomeVendorSurvey} element={<VendorSurvey />} />
        {/* <Route path={RoutePaths.henryLandingPage} element={<HenryLandingPage />} /> */}
        <Route
          path={RoutePaths.changelog}
          element={
            <>
              <HeaderComponent />
              <Changelog />
            </>
          }
        />
        <Route path={RoutePaths.passwordUpdated} element={<PasswordUpdatedScreen />} />
        <Route path="*" element={<Navigate replace to={{ pathname: route(RoutePaths.index) }} />} />
      </Routes>
    </>
  );
}
